import { render, staticRenderFns } from "./FreeVehicle.vue?vue&type=template&id=71d48ca4&"
import script from "./FreeVehicle.vue?vue&type=script&lang=js&"
export * from "./FreeVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports